import { Check } from 'lucide-react';

import { Button, cn, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { A2vOverlayPosition, a2vOverlayPositions } from '../../model';

interface OverlayPositionPickerProps {
  value: A2vOverlayPosition;
  occupied?: A2vOverlayPosition | undefined;
  disabled?: boolean;
  onChange: (position: A2vOverlayPosition) => void;
}

export function OverlayPositionPicker({
  value,
  occupied,
  disabled,
  onChange,
}: OverlayPositionPickerProps) {
  return (
    <TooltipProvider>
      <div className="border-input grid h-24 w-full grid-cols-2 overflow-hidden rounded-md border">
        {a2vOverlayPositions.map((position) => {
          const unavailable = disabled || occupied === position;
          return (
            <Tooltip key={position}>
              <TooltipTrigger asChild>
                <Button
                  type="button"
                  variant="ghost"
                  aria-label={dashboardT(positionLabelKey[position])}
                  aria-pressed={value === position}
                  disabled={unavailable}
                  className={cn(
                    'border-border h-full min-h-10 rounded-none border-0 p-0',
                    position === A2vOverlayPosition.TopLeft ||
                      position === A2vOverlayPosition.BottomLeft
                      ? 'border-r'
                      : '',
                    position === A2vOverlayPosition.TopLeft ||
                      position === A2vOverlayPosition.TopRight
                      ? 'border-b'
                      : '',
                    value === position ? 'bg-accent text-accent-foreground' : 'bg-card',
                  )}
                  onClick={() => {
                    onChange(position);
                  }}
                >
                  {value === position ? <Check className="h-4 w-4" aria-hidden="true" /> : null}
                </Button>
              </TooltipTrigger>
              <TooltipContent>{dashboardT(positionLabelKey[position])}</TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}

const positionLabelKey = {
  [A2vOverlayPosition.TopLeft]: 'a2v.networkTemplate.positions.topLeft',
  [A2vOverlayPosition.TopRight]: 'a2v.networkTemplate.positions.topRight',
  [A2vOverlayPosition.BottomLeft]: 'a2v.networkTemplate.positions.bottomLeft',
  [A2vOverlayPosition.BottomRight]: 'a2v.networkTemplate.positions.bottomRight',
} as const;
